import { ReassignUserReducerState, UpdateItemPayload } from "../types";

export const updateItem = ({ state, payload, }: { state: ReassignUserReducerState, payload: UpdateItemPayload }): ReassignUserReducerState => {
    return { ...state, items: { ...state.items, [payload.name]: payload.item } }
}